import { useUserEventLogger } from '@repo/tracking-service';

import { DEFAULT_HEADER_CLICK_EVENTS } from '@/lib/constants/tracking';
import type { LayoutClickEvent, LeftItemType, RightItemType } from '@/lib/types/layout';

export const useHeaderClickEvent = (key: LeftItemType | RightItemType, clickEvent?: LayoutClickEvent) => {
  const { sendClickEvent } = useUserEventLogger();

  return () => {
    const event = clickEvent ?? DEFAULT_HEADER_CLICK_EVENTS[key];
    sendClickEvent(event.name, event.attributes);
  };
};
